import { getTypedTools, SagaContext as UntypedSagaContext } from 'async-saga'
import { StoreState } from '../types'

export const { take, takeEvery, waitForState } = getTypedTools<StoreState>()
export type SagaContext = UntypedSagaContext<StoreState>